var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAngleLeftGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    viewBox: "0 0 7.554 13.125"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.238 5.839L1.68.291A.983.983 0 00.286 1.675l4.861 4.91-4.861 4.861a.983.983 0 101.394 1.385l5.558-5.548a.982.982 0 000-1.444z",
    fill: "#80868b"
  })));
}

export default SvgAngleLeftGray;